/**
 * Create Ticket — the appointment day may not be in the shop's past.
 *
 * Incident (Floyd's, 2026-10-05): the global selected day was still
 * 2026-09-30, Create Ticket handed that day to OptiPlace, and smart-assign —
 * correctly — refused every start as "in the past" with a 400 the operator
 * only saw as "Edge Function returned a non-2xx status code". Nothing was
 * written; the operator just could not create the ticket.
 *
 * The decision is made in the SHOP's calendar: `dayLabel` is the shop-local
 * appointment day (`yyyy-MM-dd`, as CreateTicket formats it with
 * formatInTimeZone) and "today" is `getTodayInShopTz` (the canonical,
 * clock-driven helper) — never the browser's local or UTC date. Both are
 * `yyyy-MM-dd`, so the comparison is a plain string comparison.
 *
 * Only DAYS before today are refused. Today is allowed: the existing Waiter
 * start-time guard still refuses a typed time that has already passed, and
 * smart-assign remains the final authority on start times.
 */
import { getTodayInShopTz } from './shopTime';

export const PAST_APPOINTMENT_DATE_TITLE = 'Appointment date is in the past';
export const PAST_APPOINTMENT_DATE_MESSAGE = 'Appointment date is in the past. Choose today or a future date.';

const DAY_LABEL = /^\d{4}-\d{2}-\d{2}$/;

/** True only when `dayLabel` is a valid shop-local day strictly before the shop's today. */
export function isAppointmentDayInShopPast(dayLabel: string, shopTz: string): boolean {
  if (!DAY_LABEL.test(dayLabel)) return false;   // not a day this check can judge; other validation owns it
  return dayLabel < getTodayInShopTz(shopTz);
}
